export default __webpack_public_path__ + "21.9c730f.svg";